import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f8fb8fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2f8fb8fa&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=2f8fb8fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fb8fa",
  null
  
)

export default component.exports